/** Um argumento de uma linha STEP desmontado para se mostrar: vazio
 *  ($), derivado (*), referência (#12), texto, enumerado (.T.), número,
 *  binário, lista ou valor tipado (IFCLABEL('x')). Lê-se o que está
 *  escrito; não se converte nem se interpreta nada. */

import { splitTopLevelArgs } from '../stepText'
import { descodificarTextoStep } from './textoStep'

export type ValorStep =
  | { tipo: 'vazio' }
  | { tipo: 'derivado' }
  | { tipo: 'ref'; id: number }
  | { tipo: 'texto'; valor: string }
  | { tipo: 'enum'; valor: string }
  | { tipo: 'numero'; bruto: string }
  | { tipo: 'binario'; bruto: string }
  | { tipo: 'lista'; itens: ValorStep[] }
  | { tipo: 'tipado'; classe: string; valor: ValorStep }
  | { tipo: 'desconhecido'; bruto: string }

export function analisarValor(arg: string): ValorStep {
  const t = arg.trim()
  if (t === '$' || t === '') return { tipo: 'vazio' }
  if (t === '*') return { tipo: 'derivado' }
  const ref = /^#(\d+)$/.exec(t)
  if (ref) return { tipo: 'ref', id: parseInt(ref[1], 10) }
  if (t.startsWith("'") && t.endsWith("'") && t.length >= 2) {
    return { tipo: 'texto', valor: descodificarTextoStep(t.slice(1, -1)) }
  }
  if (/^\.[A-Za-z0-9_]+\.$/.test(t)) return { tipo: 'enum', valor: t.slice(1, -1) }
  if (/^[+-]?(\d+\.?\d*|\.\d+)([eE][+-]?\d+)?$/.test(t)) return { tipo: 'numero', bruto: t }
  if (/^"[0-9A-Fa-f]*"$/.test(t)) return { tipo: 'binario', bruto: t }
  if (t.startsWith('(') && t.endsWith(')')) {
    const dentro = t.slice(1, -1).trim()
    return { tipo: 'lista', itens: dentro === '' ? [] : splitTopLevelArgs(dentro).map(analisarValor) }
  }
  const tip = /^([A-Za-z][A-Za-z0-9_]*)\s*\(([\s\S]*)\)$/.exec(t)
  if (tip) return { tipo: 'tipado', classe: tip[1].toUpperCase(), valor: analisarValor(tip[2]) }
  return { tipo: 'desconhecido', bruto: t }
}

/** Quantos valores folha tem (para decidir se uma lista se mostra inteira). */
export function tamanhoDoValor(v: ValorStep): number {
  if (v.tipo === 'lista') return v.itens.reduce((n, x) => n + tamanhoDoValor(x), 0)
  if (v.tipo === 'tipado') return tamanhoDoValor(v.valor)
  return 1
}

/** Em que argumento de topo aparece a referência a `alvo` (o primeiro), ou -1. */
export function argumentoQueReferencia(args: string[], alvo: number): number {
  const re = new RegExp(`#${alvo}(?![0-9])`)
  for (let i = 0; i < args.length; i++) {
    // Fora de textos: tira-se o que está entre plicas antes de procurar.
    if (re.test(args[i].replace(/'(?:[^']|'')*'/g, "''"))) return i
  }
  return -1
}
